import { Box, Flex, IconButton, Spacer, Text, useColorMode } from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";
import { ColorModeSwitcher } from '../../ColorModeSwitcher';

const Navbar = (props) => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";

  const clickLinekedin = () => {
    window.open('https://in.linkedin.com/in/ankushsankhe999', '_blank').focus()
  }

  return (  
        <Box p="2" bg={isDark ? "gray.800" : "white"}
        pos="fixed" w="100%" zIndex={2}>
        <Flex>
          <Box p="2" style={{display: 'flex'}}>
          <img alt="CompoundCalc" src={window.location.origin + '/logo.png'} width={36} height={36}/>
          <Text fontSize="l" 
                fontWeight="bold" 
                m="1"
                bgGradient={isDark ? 
                "linear(red.100 0%, orange.100 25%, yellow.100 50%)" :
                "linear(to-r, cyan.400, blue.500, purple.600)"} 
                bgClip='text' >CoumpoundCalc</Text>
          </Box>
          <Spacer />
          <Box>
            <IconButton
              size="lg"
              fontSize="xl"
              aria-label={`Ankush Sankhe LinekedIn`}
              variant="ghost"
              color="linkedin"
              marginLeft="2"
              isRound
              onClick={clickLinekedin}
              icon={<FaLinkedin />}
              {...props}
            />
            <ColorModeSwitcher justifySelf="flex-end" />
          </Box>
        </Flex>
        </Box>
);
}

export default Navbar;